/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import React, { Component } from "react";

class Texture extends Component {
  constructor(props) {
    super(props);
    // @props: className - String
    // @props: imageURL - String
    // @props: opacity - String
    // @props: style - Object

    this.state = {};
  }

  render() {
    const { props } = this;
    const { className, imageUrl, opacity, style } = props;

    return (
      <div
        className={className || ""}
        style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: "cover",
            height: "100%",
            opacity: opacity || "33%",
            transition: "all .5s linear",
            width: "100%",
            zIndex: 1,
            ...style
        }}
      />
    );
  }
}
export default Texture;
